import script from "./MainwaveScorerView.vue?vue&type=script&setup=true&lang=js"
export * from "./MainwaveScorerView.vue?vue&type=script&setup=true&lang=js"

import "./MainwaveScorerView.vue?vue&type=style&index=0&id=7b024756&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7b024756"]])

export default __exports__